import { render, staticRenderFns } from "./LeadDesabonner.vue?vue&type=template&id=11c53385&"
import script from "./LeadDesabonner.vue?vue&type=script&lang=js&"
export * from "./LeadDesabonner.vue?vue&type=script&lang=js&"
import style0 from "./LeadDesabonner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports